import styled from "styled-components";
import { ids } from "@icarros/theme-react";
const { size } = ids || {};
export const StyledCardContainer = styled.div `
  padding: ${size.general.ids_size_general_24x};
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
export const StyledIconsContainer = styled.div `
  display: flex;
  gap: ${size.general.ids_size_general_4x};
`;
export const StyledBodyContainer = styled.div `
  display: block;
`;
//# sourceMappingURL=HomeCard.style.js.map